module.exports = __webpack_public_path__ + "img/p1.4598cb58.png";